import { useState } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";

interface VotingGridProps {
  votingOptions: (number | string)[];
  selectedStoryId: string | null;
  currentUserId: string | null;
  onVote: (
    storyId: string | null,
    userId: string | null,
    size: number | null
  ) => void;
}

export function VotingGrid({
  votingOptions,
  selectedStoryId,
  currentUserId,
  onVote,
}: VotingGridProps) {
  const [selectedVote, setSelectedVote] = useState<number | null | undefined>(
    undefined
  );

  return (
    <>
      <h5 className="fw-semibold mb-3">Vote your estimate</h5>
      <Container>
        <Row xs={3} md={4} className="g-3">
          {votingOptions.map((size, idx) => {
            const voteValue = size === "?" ? null : (size as number);
            // Check if this option matches the selected vote
            const isVoted =
              selectedVote !== undefined &&
              ((selectedVote === null && size === "?") ||
                (selectedVote !== null && selectedVote === voteValue));

            return (
              <Col key={idx}>
                <Button
                  variant={isVoted ? "primary" : "outline-primary"}
                  className="w-100 rounded-pill"
                  size="lg"
                  onClick={() => {
                    console.log("Vote click", {
                      selectedStoryId,
                      currentUserId,
                      size,
                    });
                    setSelectedVote(voteValue); // Update selected vote immediately
                    onVote(selectedStoryId, currentUserId, voteValue);
                  }}
                  disabled={selectedStoryId == null || currentUserId == null}
                >
                  {size}
                </Button>
              </Col>
            );
          })}
        </Row>
      </Container>
    </>
  );
}
